import MenuItemOption from '@/components/MenuItemOption/MenuItemOption.vue';

export default {
  name: 'MenuItemOptions',
  components: {
    MenuItemOption,
  },
  props: {
    entree: {
      required: true,
      type: Object,
    },
    entreeIdentifier: {
      required: true,
      type: Number,
    },
    options: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selectedOptions: {},
    };
  },
  computed: {
    validationItems() {
      const items = {};
      for (let i = 0; i < this.options?.length; i += 1) {
        const { index, rules: { min } } = this.options[i] || {};
        items[index] = !(+min > 0);
      }
      return items;
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  watch: {
    selectedOptions: {
      deep: true,
      handler() {
      },
    },
  },
  methods: {
    validateOptions(infos, optionIndex) {
      this.validationItems[optionIndex] = infos;
      this.$emit('is-options-valid', Object.keys(this.validationItems).every((key) => this.validationItems[key]));
    },
  },
};
